export function buildPaypalReturnUrl(cartId?: string): string {
  const query = cartId ? `?cartId=${encodeURIComponent(cartId)}` : '';
  return `${window.location.origin}/#/purchase/confirm${query}`;
}

export function buildPaypalCancelUrl(cartId?: string): string {
  const query = cartId ? `?cartId=${encodeURIComponent(cartId)}` : '';
  return `${window.location.origin}/#/purchase/cancel${query}`;
}
